import(/* webpackMode: "eager" */ "/app/src/app/[locale]/contact/test-sample-request/page.js")